import { combineReducers } from 'redux'
import appReducer from './app'
import formReducer from './form'
import dataReducer from './data'
import feedReducer from './feed'
import videoReducer from './video'

module.exports = combineReducers({
  app: appReducer,
  form: formReducer,
  data: dataReducer,
  feed: feedReducer,
  video: videoReducer
})



// WEBPACK FOOTER //
// ./src/shared/reducers/index.js